import { MAAT_SOR_CODE } from '../constants/maat-sor-code.constants';

export class MaatSorCodeParser {

  public static extractSuffix(sorCode: string): string
  {
    const suffix = sorCode === MAAT_SOR_CODE.fakeSorCodeForNosJobItem
      ? MAAT_SOR_CODE.fakeSorCodeSuffixForNosJobItem
      : (sorCode && sorCode.length === MAAT_SOR_CODE.sorCodeLength)
          ? sorCode.slice(-MAAT_SOR_CODE.sorCodeSuffixLength)
          : null;

      return suffix;
  }
}
